var map = {
	"./credit.png": "2e01",
	"./wt-order-alipay.png": "bc50",
	"./wt-order-bonus.png": "f8d2",
	"./wt-order-unionpay.png": "84ad",
	"./wt-order-wx.png": "82bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "923f";